import React from 'react';

export default {
	'Error.Unknown': 'Error desconocido',
	'Error.Unknown.Message': 'Se ha producido un error.',
	'Error.NotFound': 'Extraviado',
	'Error.NotFound.Message': 'No se pudo encontrar la página solicitada.',
	'Error.Forbidden': 'Prohibida',
	'Error.Forbidden.Message': 'No tienes permiso para acceder a esta página.',
	'Error.Invalid': 'Entrada no válida',
	'Error.Invalid.Message': 'Campos no válidos: {{fields}}.',
	'Error.FileSize.Message': 'El archivo que intentaste subir era demasiado grande.',
	'PTMD Portal': 'PTMD Portal',
	'Login': 'Acceso',
	'Logout': 'Cerrar sesión',
	'FileDrop.Release': 'Suelte para seleccionar el archivo',
	'FileDrop.Drag': () => <h5>Arrastra y suelta un archivo aquí<br/> o </h5>,
	'FileDrop.Select': 'Selecciona un archivo',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} bytes',
	'FileSize.Max': 'El tamaño máximo de carga es de {{size}}',
	'Modal.Open': 'Abierto',
	'Modal.Close': 'Cerca',
	'Language': 'Idioma'
};
